/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AddressUtils__InsufficientBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "AddressUtils__NotContract",
        type: "error",
    },
    {
        inputs: [],
        name: "AddressUtils__SendValueFailed",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea2646970667358221220d2a72d0c49d6a0a0c24a80f3f9a51c58caf96d0b8ecdcfcfce565cb77c2daf1864736f6c63430008140033";
const isSuperArgs = (xs) => xs.length > 1;
export class AddressUtils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
AddressUtils__factory.bytecode = _bytecode;
AddressUtils__factory.abi = _abi;
